import * as types from "./../../store/mutation-types.js";
import * as globalMutationTypes from "@/store/mutation-types.js";

import icons from "@/mixins/icons.js";
import bo from "@/mixins/basic-operations.js";
import ValidationService from '@/services/validation.service.js'
import AS from "./../../services/agenda-global/agenda.service.js";
import _ from "lodash";

import RSM from "wisaapp-webstudent/src/mixins/right-side-menu.js";
import { getAccountInfo } from "../../store/actions.js";
// import tab from "@/components/utils/tab/tab.vue";
const agendaService = new AS();

const validationService = new ValidationService()
export default {
  name: "betalingen",
  mixins: [icons, bo, RSM],
  // components: {
  //   // tab
  // },
  data: function () {
    return {

      cursistInfo: this.$store.state.wstudent.cursistInfo,
      BetalingenList: []

    };
  },

  created: function () {
    this.$store.commit("wstudent/" + types.ZET_CURRENT_SCREEN, "betalingen");
  },
  beforeCreate: function () {

  },
  computed: {

  },
  watch: {

  },
  mounted: function () {

    this.getBetalingenList()


    this.$store.commit(globalMutationTypes.SET_MENUBAR_ITEMS, {
      changePartially: true,
      left: "menu",
      title: 'Betalingen',
      right: []
    });
  },

  methods: {
    getBetalingenList() {
      this.$store.dispatch("wstudent/" + "getBetalingen", this.cursistInfo[0].ID).then(result => {
        console.log(result)
        // this.BetalingenList =_.sortBy(result, function(o) { return new moment(o.Inschrijfdatum); });
        result.map(function (e) {
          return e.Inschrijfdatum = moment(e.Inschrijfdatum, 'DD/MM/YYYY').format('YYYY-MM-DD')


        });

        this.BetalingenList = _.orderBy(result, function (o) { return new moment(o.Inschrijfdatum, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss'); }, ['desc'])

      })
    }

  }
};
